import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card, Row, Col, Dropdown } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { ADJUSTABLE_DIM } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyPicker from './components/PropertyPicker';
import Checkbox from 'components/shared/StandaloneCheckbox';
import AdjustableDimChart from './charts/AdjustableDimChart'
import Radio from 'components/shared/StandaloneRadio';
import { Trans, withTranslation } from 'react-i18next';

class AdjustableDim extends BaseFeature {

    constructor(props) {
        super(props);

        // 1-10V Dimming;9;1;Off;Off;10|
        // 0-10V Dimming;9;1;9.3;9.5;10|
        // 1-5V Dimming;4.5;0.5;Off;Off;10|
        // 1-10V Dimming;4.5;0.5;4.5;4.3;10"

        // 1-10V Dimming;1;9;Off;Off;10|
        // 0-10V Dimming;1;9;0.7;0.5;10|
        // 1-5V Dimming;0.5;4.5;Off;Off;10|
        // 1-10V Dimming;0.5;4.5;0.5;0.3;10"

        const presetValuesPropertyNames = ["name", "x", "y", "on", "off", "minDim"];

        let presetValuesTempPos = [];
        let presetValuesTempNeg = [];
        let foundDirection = 'Positive';
        let foundCurve = 'custom';

        if(this.props.properties[ADJUSTABLE_DIM.presetCurvesPos]){
            presetValuesTempPos = this.props.properties[ADJUSTABLE_DIM.presetCurvesPos].value.replace(/^Custom\|/, '').split('|').map(item => {
                const values = item.split(';').map(value => isNaN(value) || value === "Off" ? value : Number(value));
                return Object.fromEntries(presetValuesPropertyNames.map((key, index) => [key, values[index]]));
            });
            presetValuesTempNeg = this.props.properties[ADJUSTABLE_DIM.presetCurvesNeg].value.replace(/^Custom\|/, '').split('|').map(item => {
                const values = item.split(';').map(value => isNaN(value) || value === "Off" ? value : Number(value));
                return Object.fromEntries(presetValuesPropertyNames.map((key, index) => [key, values[index]]));
            });

            // check if values match any curve
            let xPoint = Number(this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue].value);
            let yPoint = Number(this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue].value);
            let triggerDimOn = this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].value === "Off" ? this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].value : Number(this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].value);
            let triggerDimOff = this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].value === "Off" ? this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].value : Number(this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].value);
            let minCurrent = Number(this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage].value);

            let searchCurve = presetValuesTempPos.findIndex(item => item.x === xPoint && item.y === yPoint && item.on === triggerDimOn && item.off === triggerDimOff && item.minDim === minCurrent);

            if(searchCurve !== -1){
                foundDirection = 'Positive';
                foundCurve = presetValuesTempPos[searchCurve].name;
            } else {
                searchCurve = presetValuesTempNeg.findIndex(item => item.x === xPoint && item.y === yPoint && item.on === triggerDimOn && item.off === triggerDimOff && item.minDim === minCurrent);
                if(searchCurve !== -1){
                    foundDirection = 'Negative';
                    foundCurve = presetValuesTempNeg[searchCurve].name;
                }
            }

            if(xPoint > yPoint){
                foundDirection = 'Negative';
            } else if(yPoint > xPoint){
                foundDirection = 'Positive';
            }
        }

        this.state = {
            isCheckedDimOnOff: this.isOn(this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint]),
            selectedCurve: foundCurve,
            typicalCurveDirection: foundDirection,
            presetCurvesPos: presetValuesTempPos,
            presetCurvesNeg: presetValuesTempNeg,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCheckboxes = this.handleChangeCheckboxes.bind(this);
        this.handleChangeTypicalCurve = this.handleChangeTypicalCurve.bind(this);

    }

    isOn(property) {
        return property != null && property.value !== 'Off' && property.value !== property.valueMeta.off;
    }

    handleChange(propertyName, value, doNotChangeTypicaCurve = false) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };
        // this.setState({ dimmingEnabled: v === "1" ? true : false });

        this.props.handleChange(propertyName, v);
        if(propertyName === 'ajdim.xv' || propertyName === 'ajdim.yv' || propertyName === 'ajdim.tron' || propertyName === 'ajdim.troff' || propertyName === 'ajdim.xcur'){
            if(doNotChangeTypicaCurve === false){
                this.setState({selectedCurve: 'custom'});
            }
        }
    }

    handleChangeTypicalCurve(e) {
        if(this.state.presetCurvesPos.length === 0){
            return;
        }
        // make selection stick, update local state
        let direction = this.state.typicalCurveDirection;
        let curve = this.state.selectedCurve;
        let curvePosition = this.state.presetCurvesPos.findIndex(item => item.name === curve);

        if(e.target.name === 'direction'){
            this.setState({ typicalCurveDirection: e.target.id });
            direction = e.target.id;
        } else if(e.target.name === 'typicalCurve'){
            this.setState({ selectedCurve: e.target.id });
            curve = e.target.id;
            curvePosition = this.state.presetCurvesPos.findIndex(item => item.name === curve);
        }
        // make changes
        const xPoint = this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue];
        const yPoint = this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue];
        let triggerDimOn = this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint];
        let triggerDimOff = this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint];
        let minCurrent = this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage];

        // flip direction in custom mode
        const tempX = xPoint.value;
        const tempY = yPoint.value;
        if(curve === 'custom'){
            if(direction === 'Positive' && xPoint.value > yPoint.value){
                // flip
                this.handleChange(xPoint.info.name, tempY, true);
                this.handleChange(yPoint.info.name, tempX, true);
            } else if(direction === 'Negative' && yPoint.value > xPoint.value){
                // flip
                this.handleChange(xPoint.info.name, tempY, true);
                this.handleChange(yPoint.info.name, tempX, true);
            }
            return;
        }

        if(direction === 'Positive'){
            this.handleChange(xPoint.info.name, this.state.presetCurvesPos[curvePosition].x, true);
            this.handleChange(yPoint.info.name, this.state.presetCurvesPos[curvePosition].y, true);
            this.handleChange(triggerDimOn.info.name, this.state.presetCurvesPos[curvePosition].on, true);
            this.handleChange(triggerDimOff.info.name, this.state.presetCurvesPos[curvePosition].off, true);
            this.setState({ isCheckedDimOnOff: this.state.presetCurvesPos[curvePosition].on !== "Off" });
            this.handleChange(minCurrent.info.name, this.state.presetCurvesPos[curvePosition].minDim, true);
        } else if (direction === 'Negative'){
            this.handleChange(xPoint.info.name, this.state.presetCurvesNeg[curvePosition].x, true);
            this.handleChange(yPoint.info.name, this.state.presetCurvesNeg[curvePosition].y, true);
            this.handleChange(triggerDimOn.info.name, this.state.presetCurvesNeg[curvePosition].on, true);
            this.handleChange(triggerDimOff.info.name, this.state.presetCurvesNeg[curvePosition].off, true);
            this.setState({ isCheckedDimOnOff: this.state.presetCurvesNeg[curvePosition].on !== "Off" });
            this.handleChange(minCurrent.info.name, this.state.presetCurvesNeg[curvePosition].minDim, true);

        }

    }

    handleChangeCheckboxes(e) {
        const checked = e.target.checked;

        switch (e.target.name) {
            case "dimonoff":
                let triggerDimOn = this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint];
                let triggerDimOff = this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint];

                triggerDimOn.value = checked ? this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].valueMeta.initial : "Off";
                triggerDimOff.value = checked ? this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].valueMeta.initial : "Off";

                this.handleChange(triggerDimOn.info.name, triggerDimOn.value);
                this.handleChange(triggerDimOff.info.name, triggerDimOff.value);

                this.setState({ isCheckedDimOnOff: checked });
                break;
            default:
                break;
        }
    }

    render() {
        const { t } = this.props;
        const curveTypeProperty = this.props.properties[ADJUSTABLE_DIM.curveSelection];
        const curveType = curveTypeProperty && curveTypeProperty.value && curveTypeProperty.value.toLowerCase() === 'logarithmic' ? 'Logarithmic' : 'Linear';
        return (
            <Row>
                <Col lg={6} md={6} sm={12} style={{minWidth: '700px'}}>
                    <Col lg={12} md={12} sm={12}>
                        <Card className="card-feature-component" style={{ width: '100%'}}>
                            <div className="card-header-feature">
                                {<Trans i18nKey="Adjustable_Dim" />}
                            </div>
                            <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                                <PropertyDropdown
                                    translate={true}
                                    property={this.props.properties[ADJUSTABLE_DIM.outputResponseSelection]}
                                    properties={this.props.properties[ADJUSTABLE_DIM.outputResponseSelection].valueMeta.availableValues}
                                    title={this.props.properties[ADJUSTABLE_DIM.outputResponseSelection].info.displayName}
                                    measureUnit={''}
                                    step={1}
                                    handleChange={this.handleChange}
                                    dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                    titleSize={6}
                                    dropdownSize={6} />

                                <PropertyPicker
                                    // disabled={this.props.properties[ADJUSTABLE_DIM.enable].value === '1' ? false : true}
                                    property={this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue]}
                                    title={this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue].info.displayName + " (V)"}
                                    margin="0.75rem auto"
                                    // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                    min={this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue].valueMeta.min}
                                    max={this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue].valueMeta.max}
                                    inputStyle={{ padding: "0", maxWidth: "auto" }}
                                    titleSize={10}
                                    inputSize={2}
                                    step={0.1}
                                    handleChange={this.handleChange} />

                                <PropertyPicker
                                    // disabled={this.props.properties[ADJUSTABLE_DIM.enable].value === '1' ? false : true}
                                    property={this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue]}
                                    title={this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue].info.displayName + " (V)"}
                                    margin="0.75rem auto"
                                    // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                    min={this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue].valueMeta.min}
                                    max={this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue].valueMeta.max}
                                    inputStyle={{ padding: "0", maxWidth: "auto" }}
                                    titleSize={10}
                                    inputSize={2}
                                    step={0.1}
                                    handleChange={this.handleChange} />

                                <PropertyPicker
                                    // disabled={this.props.properties[ADJUSTABLE_DIM.enable].value === '1' ? false : true}
                                    property={this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage]}
                                    title={this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage].info.displayName + " (%)"}
                                    margin="0.75rem auto"
                                    // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                    min={this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage].valueMeta.min}
                                    max={this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage].valueMeta.max}
                                    inputStyle={{ padding: "0", maxWidth: "auto" }}
                                    titleSize={10}
                                    inputSize={2}
                                    step={0.1}
                                    handleChange={this.handleChange} />

                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={12} md={12} sm={12}>
                        <Card className="card-feature-component" style={{ width: '100%'}}>
                            <div className="card-header-feature">
                                {<Trans i18nKey="Dim_to_Off" />}
                            </div>
                            <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                                <Checkbox
                                    name={"dimonoff"}
                                    checked={this.state.isCheckedDimOnOff}
                                    style={{ margin: "auto 0.5rem" }}
                                    onChange={this.handleChangeCheckboxes}
                                />
                                {<Trans i18nKey="Enable_Disable_DimOnOff" />}

                                <PropertyPicker
                                    disabled={!this.state.isCheckedDimOnOff}
                                    property={this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint]}
                                    title={this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].info.displayName + ""}
                                    margin="0.75rem auto"
                                    // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                    min={this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].valueMeta.min}
                                    max={this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].valueMeta.max}
                                    inputStyle={{ padding: "0", maxWidth: "auto" }}
                                    titleSize={10}
                                    inputSize={2}
                                    step={0.1}
                                    handleChange={this.handleChange} />

                                <PropertyPicker
                                    disabled={!this.state.isCheckedDimOnOff}
                                    property={this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint]}
                                    title={this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].info.displayName + ""}
                                    margin="0.75rem auto"
                                    // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                    min={this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].valueMeta.min}
                                    max={this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].valueMeta.max}
                                    inputStyle={{ padding: "0", maxWidth: "auto" }}
                                    titleSize={10}
                                    inputSize={2}
                                    step={0.1}
                                    handleChange={this.handleChange} />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={12} md={12} sm={12}>
                        <Card className="card-feature-component" style={{ width: '100%'}}>
                            <div className="card-header-feature">
                                {<Trans i18nKey="Airborne" />}
                            </div>
                            <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                                <PropertySwitch
                                    property={this.props.properties[ADJUSTABLE_DIM.enableAirborne]}
                                    title={this.props.properties[ADJUSTABLE_DIM.enableAirborne].info.displayName}
                                    handleChange={this.handleChange} />

                                <PropertyDropdown
                                    translate={true}
                                    disabled={this.props.properties[ADJUSTABLE_DIM.enableAirborne].value === "0"}
                                    property={this.props.properties[ADJUSTABLE_DIM.outputSettingsWhenAirborne]}
                                    properties={this.props.properties[ADJUSTABLE_DIM.outputSettingsWhenAirborne].valueMeta.availableValues}
                                    title={this.props.properties[ADJUSTABLE_DIM.outputSettingsWhenAirborne].info.displayName}
                                    measureUnit={''}
                                    step={1}
                                    handleChange={this.handleChange}
                                    dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                    titleSize={6}
                                    dropdownSize={6} />

                                <PropertyPicker
                                    disabled={this.props.properties[ADJUSTABLE_DIM.enableAirborne].value === "0"}
                                    property={this.props.properties[ADJUSTABLE_DIM.airborneVoltage]}
                                    title={this.props.properties[ADJUSTABLE_DIM.airborneVoltage].info.displayName + " (V)"}
                                    margin="0.75rem auto"
                                    // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                    min={this.props.properties[ADJUSTABLE_DIM.airborneVoltage].valueMeta.min}
                                    max={this.props.properties[ADJUSTABLE_DIM.airborneVoltage].valueMeta.max}
                                    inputStyle={{ padding: "0", maxWidth: "auto" }}
                                    titleSize={10}
                                    inputSize={2}
                                    step={0.1}
                                    handleChange={this.handleChange} />

                            </Card.Body>
                        </Card>
                    </Col>

                </Col>
                <Col lg={6} md={6} sm={12} style={{minWidth: '700px'}}>
                    <Col lg={12} md={12} sm={12}>
                        <Card className="card-feature-component" style={{ width: '100%'}}>
                            <div className="card-header-feature">
                                {<Trans i18nKey="Typical_curves" />}
                            </div>
                            <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                                <Row>
                                    <Col lg={6} md={6} sm={6}>
                                        <div style={{ display: "flex" }}>
                                            <Radio
                                                name="typicalCurve"
                                                id="custom"
                                                checked={this.state.selectedCurve === "custom"}
                                                onClick={this.handleChangeTypicalCurve}
                                            />
                                            <p style={{ margin: "8px 0 0 0" }}>
                                                <Trans i18nKey="Custom" />
                                            </p>
                                        </div>

                                        {this.state.presetCurvesPos.map((option, index) => {
                                            const id = option['name'];
                                            return (
                                                <div style={{ display: "flex" }}>
                                                    <Radio
                                                        name="typicalCurve"
                                                        id={id}
                                                        checked={this.state.selectedCurve === id}
                                                        onClick={this.handleChangeTypicalCurve}
                                                    />
                                                    <p style={{ margin: "8px 0 0 0" }}>{option['name'].replace('Dimming', t('Dimming'))}</p>
                                                </div>
                                            );
                                        })}

                                    </Col>
                                    <Col lg={6} md={6} sm={6}>
                                        <div style={{ display: "flex", gap: "1rem" }}>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="secondary" style={{margin: '0'}} disabled={this.state.selectedCurve === 'custom'}>{this.state.typicalCurveDirection.replace('Positive', t('Positive')).replace('Negative', t('Negative'))}</Dropdown.Toggle>
                                                <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                                    <Dropdown.Item onClick={this.handleChangeTypicalCurve} name={'direction'} id={'Positive'} key={'Positive'} >{<Trans i18nKey="Positive" />}</Dropdown.Item>
                                                    <Dropdown.Item onClick={this.handleChangeTypicalCurve} name={'direction'} id={'Negative'} key={'Negative'} >{<Trans i18nKey="Negative" />}</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {curveTypeProperty &&
                                                <PropertyDropdown
                                                    translate={true}
                                                    property={curveTypeProperty}
                                                    properties={curveTypeProperty.valueMeta.availableValues}
                                                    handleChange={this.handleChange}
                                                    margin={0}
                                                    dropdownStyle={{ margin: '0' }}
                                                    dropdownSize={12} />
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={12} md={12} sm={12}>
                        <Card className="card-feature-component" style={{ width: '100%'}}>
                            <div className="card-header-feature">
                                {<Trans i18nKey="Graph" />}
                            </div>
                            <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                                <AdjustableDimChart
                                    ON={this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint].value}
                                    OFF={this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint].value}
                                    Xvoltage={this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue].value}
                                    Yvoltage={this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue].value}
                                    MinDim={this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage].value}
                                    propertyOff={this.props.properties[ADJUSTABLE_DIM.triggerDimOffVoltagePoint]}
                                    propertyOn={this.props.properties[ADJUSTABLE_DIM.triggerDimOnVoltagePoint]}
                                    propertyX={this.props.properties[ADJUSTABLE_DIM.xPointVoltageValue]}
                                    propertyY={this.props.properties[ADJUSTABLE_DIM.yPointVoltageValue]}
                                    propertyDim={this.props.properties[ADJUSTABLE_DIM.minimumOutputCurrentPercentage]}
                                    airbornVoltage={this.props.properties[ADJUSTABLE_DIM.airborneVoltage].value}
                                    enableAirborne={this.props.properties[ADJUSTABLE_DIM.enableAirborne].value}
                                    outputSettingsWhenAirborne={this.props.properties[ADJUSTABLE_DIM.outputSettingsWhenAirborne].value}
                                    curveType={curveType}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Col>

            </Row>
        );
    }

}

// export default connect()(AdjustableDim);
// export default withTranslation()(AdjustableDim);
export default compose(
    connect(),
    withTranslation()
)(AdjustableDim);
